// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__1rPZe","consentsList":"PatientConsents_consentsList__2gZLI","consentsListEmpty":"PatientConsents_consentsListEmpty__L_TJE"};